import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";

import Modal from 'react-modal';
import Switch from "react-switch";
import { useForm } from 'react-hook-form';

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faCalendar, faArrowLeft, faGift, faXmark } from "@fortawesome/free-solid-svg-icons";


const CreationEventPage = (props) => {
    const token = localStorage.getItem("JWT");

    const [modalIsOpen, setIsOpen] = React.useState(false);         //gestion de la modal
    const [isQL, setIsQL] = useState(false);         //gestion de la modal
    const [allStuff, setAllStuff] = useState([]);
    const [allMember, setAllMember] = useState([]);
    const [reward, setReward] = useState(null);
    const [cardStyle, setCardStyle] = useState(0);
    const [responsableLength, setResponsableLength] = useState(1);
    const [RadioSwitch, setRadioSwitch] = useState(0);
    const [rewardGenre, setRewardGenre] = useState("");
    const [rewardName, setRewardName] = useState("");

    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm(    // declaration du formulaire et des fonctions nécessaire
        {
            defaultValues: {
                //event
                jour: "",
                titre: "",
                responsable: "",
                responsable2: "",
                responsable3: "",
                type: "",
                branche: "",
                sousBranche: "",
                PRV: "Port Tressler",
                date: "",
                heure: "20h45",
                PP: "2",
                UEC: "20000",
                warbond: "0",
                quetes: false,
                open: false,
                genre: "",
            }
        }
    );

    //----------------------------------------------------Gestion de la modal-----------------------------------------------//

    function openModal(e) {         // ouverture de la modale et gestion d'un etat pour savoir quelle jour est concerné
        setIsOpen(true);
        e.preventDefault()
    }

    function closeModal() {         // fermeture de la modal
        setIsOpen(false);
    }

    const customStyles = {      // gestion du style de la modal
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: "80%",
            height: "80%",
            backgroundColor: "#1a1a1a",
            outline: " 15px solid rgba(18, 18, 18, 0.35)",
            borderRadius: "0px"
        },
    };

    function selectReward(e) {      // applique une reward pour un jour en particulier
        e.preventDefault()

        let rewardName = e.target.dataset.nom

        setReward(e.target.id)
        setRewardName(rewardName)
        setIsOpen(false);

    }

    function deleteReward(e) {      // supprimer la reward

        setReward(null)
        setIsOpen(false);

    }

    const searchBar = (e) => {      //barre de recherche
        let search = e.target.value;
        search = search.toUpperCase();
        let x = document.getElementsByClassName('modal__images__card');

        for (const list of x) {
            let listTitle = list.firstChild
            listTitle = listTitle.nextElementSibling
            listTitle = listTitle.innerHTML

            if (!listTitle.toUpperCase().includes(search)) {
                list.style.display = "none";
            }
            else {
                list.style.display = "flex";
            }
        }
    }

    //----------------------------------------------------Get all data-----------------------------------------------//

    function getAllUsers() {          // recupère tout les membres FCU
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/auth/userEncadrement`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },

        })
            .then((res) => {
                const membresFiltres = res.data.filter((membre) => {
                    if (membre.encadrements) {
                        return membre.encadrements.some((encadrement) => encadrement.priorite >= 2);
                    }
                    return false;
                });

                setAllMember(membresFiltres)
            })
            .catch((err) => {
                console.log(err);
            })
    }

    function getCartes() {          // recupère les cartes
        setRewardGenre("Carte")
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allcartes`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },

        })
            .then((res) => {
                setAllStuff(res.data)
                setCardStyle(0)
            })
            .catch((err) => {
                console.log(err);
            })
    }

    function getAvatars() {         // recupère les avatars
        setRewardGenre("Avatar")
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allAvatars`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },

        })
            .then((res) => {
                setAllStuff(res.data)
                setCardStyle(1)
            })
            .catch((err) => {
                console.log(err);
            })
    }

    function getCadres() {         // recupère les avatars
        setRewardGenre("Cadre")
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allCadres`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },

        })
            .then((res) => {
                setAllStuff(res.data)
                setCardStyle(0)
            })
            .catch((err) => {
                console.log(err);
            })
    }

    //----------------------------------------------------Gestion du formulaire-----------------------------------------------//

    const typeArray = ["Training flotte", "Training marines", "Event inter Orga", "Jumptown", "Logistique", "Tournoi", "Tournage", "Reunion"]
    const dayArray = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"]

    const setResponsablelength = (e) => {
        setResponsableLength(e.target.value)
    }

    const handleSelectChange = (e) => {      // Set la valeur des différents select
        let focus = e.target;
        focus.classList.add("selected-option")
    };

    const handleChange = (nextChecked, e) => { // gestion du quartier libre
        setIsQL(nextChecked)
    }

    const radioSwitch = (e) => { // gestion du quartier libre
        setValue("sousBranche", "");
        switch (e.target.id) {
            case "flotte":
                setRadioSwitch(1)
                break;

            case "marines":
                setRadioSwitch(2)
                break;

            case "logistique":
                setRadioSwitch(3)
                break;

            case "autre":
                setRadioSwitch(4)
                break;

            default:
                break;
        }
    }

    const onError = (errors) => {
        if (errors.branche) {
            toast.error("Vous devez sélectionner une branche");
        }
        if (errors.sousBranche) {
            toast.error("Vous devez sélectionner une sous branche");
        }
    };

    const addEvent = data => {          // Ajoute un event
        let description = document.querySelector(".eventDescription");

        let jour = data.jour
        let titre = data.titre
        let PRV = data.PRV
        let type = data.type
        let branche = data.branche
        let sousBranche = data.sousBranche
        let date = data.date
        let heure = data.heure
        let PP = data.PP
        let UEC = data.UEC
        let warbond = data.warbond
        let quetes = data.quetes
        let open = data.open
        let genre = data.genre
        let recompense = reward

        if (!isQL) {
            description = description.innerText;
        } else {
            description = null;
            titre = "Quartier libre"
        }

        //gestion des responsables
        let responsable = data.responsable
        let responsable2 = data.responsable2
        let responsable3 = data.responsable3
        let responsableArray = [responsable, responsable2, responsable3]

        // Trancher le tableau responsableArray selon la longueur souhaitée
        responsableArray = responsableArray.slice(0, responsableLength);

        // Retirer les doublons du tableau responsableArray
        responsableArray = [...new Set(responsableArray)];

        // Filtrer les valeurs vides
        responsableArray = responsableArray.filter(item => item !== "");

        // console.log(isQL);
        // console.log(jour);
        // console.log(titre);
        // console.log(responsableArray);
        // console.log(PRV);
        // console.log(type);
        // console.log(branche);
        // console.log(sousBranche);
        // console.log(date);
        // console.log(heure);
        // console.log(PP);
        // console.log(UEC);
        // console.log(warbond);
        // console.log(description);
        // console.log(quetes);
        // console.log(open);
        // console.log(genre);
        // console.log(recompense);

        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}api/addActivite`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
            data: {
                isQL,
                jour,
                titre,
                responsableArray,
                PRV,
                type,
                branche,
                sousBranche,
                date,
                heure,
                PP,
                UEC,
                warbond,
                description,
                quetes,
                open,
                genre,
                recompense
            }
        })
            .then((res) => {
                reset()
                setReward(null)
                setRewardGenre("");
                setRewardName("");
                setRadioSwitch(0)
                toast.success(`Event ajouté avec succès`);
            })
            .catch((err) => {
                toast.error(`Erreur d'ajout de l'event`);
                console.log(err);
            })
    }

    useEffect(() => {
        getAllUsers()
        getCartes()
    }, []);

    return (
        <div className='activitePage'>
            <Link className='exitButton' to="/profil"><FontAwesomeIcon icon={faArrowLeft} /></Link>


            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
                ariaHideApp={false}
            >
                <div className='modal'>
                    <div className='modal__menu'>
                        <button className='modal__menu__button' onClick={getCartes}>Cartes</button>
                        <button className='modal__menu__button' onClick={getAvatars}>Avatars</button>
                        <button className='modal__menu__button' onClick={getCadres}>Cadres</button>
                        <button className='modal__menu__closeButton' onClick={closeModal}><FontAwesomeIcon icon={faXmark} /></button>
                    </div>
                    <input className='modal__searchBar' onKeyUp={searchBar} type="text" name="search" placeholder="Rechercher" />
                    <div className='modal__images'>
                        {allStuff.map(cartes => (
                            <div key={cartes.id} onClick={selectReward} className='modal__images__card'>
                                <img style={{ objectFit: cardStyle === 1 ? 'contain' : 'cover' }} key={cartes.id} id={cartes.id} src={cartes.lien} data-nom={cartes.nom} alt="images de la boutique" />
                                <div className='modal__images__titre'>
                                    <h3>{cartes.nom}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='modal__bottom'>
                        <button onClick={deleteReward}>Supprimer la récompense</button>
                    </div>

                </div>

            </Modal>

            <ToastContainer
                position="bottom-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="dark"
            />

            <div className='activitePage__newAgenda'>
                <form onSubmit={handleSubmit(addEvent, onError)}>
                    <div className='activitePage__newAgenda__title'>
                        <h1>Création d'un event:</h1>
                    </div>
                    <div className='activitePage__newAgenda__allDayEvent'>

                        <div className='activitePage__newAgenda__allDayEvent__oneDay'>
                            <div className='activitePage__newAgenda__allDayEvent__oneDay__title'>

                                <select className="eventDay" onChange={handleSelectChange}  {...register("jour")} required>
                                    <option value="" disabled selected hidden>Jour de la semaine</option>
                                    {dayArray.map((jour) => (
                                        <option key={jour} id={jour} >{jour}</option>
                                    ))}
                                </select>

                                {!isQL &&
                                    <>
                                        <div className='rewardCont'>
                                            <button className='rewardButton' onClick={openModal}><FontAwesomeIcon style={{ color: reward ? "#ffd204" : "" }} id='rewardIcon' icon={faGift} /></button>
                                            {reward &&
                                                <p>{rewardGenre}:{rewardName}</p>
                                            }
                                        </div>

                                        <fieldset>
                                            <input
                                                type="radio"
                                                id="formation"
                                                value="formation"
                                                checked
                                                {...register("genre", { required: true })}
                                            />
                                            <label htmlFor="formation">Formation</label>
                                            <input
                                                type="radio"
                                                id="dynamique"
                                                value="dynamique"
                                                {...register("genre")}
                                            />
                                            <label htmlFor="dynamique">Event dynamique</label>
                                        </fieldset>
                                    </>
                                }

                                <label id='QL'>
                                    <span>Quartier libre?</span>
                                    <Switch
                                        onColor="#ffd204"
                                        onHandleColor="#1a1a1a"
                                        onChange={handleChange}
                                        checked={isQL}
                                    />
                                </label>
                            </div>
                            {isQL === false ?
                                <div className='activitePage__newAgenda__allDayEvent__oneDay__container'>
                                    <div className='activitePage__newAgenda__allDayEvent__oneDay__container__formTop'>
                                        <div>
                                            <label htmlFor="eventDate"><FontAwesomeIcon icon={faCalendar} /></label>
                                            <input type="text" className="eventDate smallInput" name="eventDate" {...register("date")} required />
                                        </div>
                                        <div>
                                            <label htmlFor="eventHeure"><FontAwesomeIcon icon={faClock} /></label>
                                            <input type="text" className="eventHeure smallInput" name="eventHeure" {...register("heure")} required defaultValue={"20h45"} />
                                        </div>
                                        <div>
                                            <label htmlFor="eventPp">PP</label>
                                            <input type="number" className="eventPp numberImput" name="eventPp" {...register("PP")} defaultValue={2} required />
                                        </div>

                                        <div>
                                            <label htmlFor="eventUEC">aUEC</label>
                                            <input type="number" className="eventUEC smallInput" name="eventUEC" {...register("UEC")} defaultValue={20000} required />
                                        </div>

                                        <div>
                                            <label htmlFor="eventWarbond">Warbonds</label>
                                            <input type="number" className="eventWarbond smallInput" name="eventWarbond" {...register("warbond")} defaultValue={0} required />
                                        </div>
                                    </div>

                                    <div className='activitePage__newAgenda__allDayEvent__oneDay__container__formBot'>
                                        <div className='activitePage__newAgenda__allDayEvent__oneDay__container__formleft'>

                                            <input type="text" className="eventTitre" name="eventTitre" placeholder='Titre:' {...register("titre")} required />

                                            <input type="text" className="eventPrv" name="eventPrv" placeholder='PRV'{...register("PRV")} required />

                                            <select onChange={handleSelectChange} {...register("type")} required>
                                                <option value="" disabled selected hidden>Type</option>
                                                {typeArray.map((type) => (
                                                    <option key={type} value={type} >{type}</option>
                                                ))}
                                            </select>

                                            <fieldset>
                                                <legend>Définir un logo pour l'event</legend>
                                                <input
                                                    type="radio"
                                                    id="marines"
                                                    value="marines"
                                                    onClick={radioSwitch}
                                                    {...register("branche", { required: true })}
                                                />
                                                <label htmlFor="marines">Marines</label>
                                                <input
                                                    type="radio"
                                                    id="flotte"
                                                    value="flotte"
                                                    onClick={radioSwitch}
                                                    {...register("branche", { required: true })}
                                                />
                                                <label htmlFor="flotte">Flotte</label>
                                                <input
                                                    type="radio"
                                                    id="logistique"
                                                    value="logistique"
                                                    onClick={radioSwitch}
                                                    {...register("branche", { required: true })}
                                                />
                                                <label htmlFor="logistique">Logistique</label>
                                                <input
                                                    type="radio"
                                                    id="autre"
                                                    value="autre"
                                                    onClick={radioSwitch}
                                                    {...register("branche", { required: true })}
                                                />
                                                <label htmlFor="autre">Autre</label>

                                            </fieldset>
                                            {RadioSwitch === 1 &&
                                                <fieldset>
                                                    <legend>Définir une image pour l'event</legend>
                                                    <input
                                                        type="radio"
                                                        id="GAN"
                                                        value="GAN"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="GAN">G.A.N</label>
                                                    <input
                                                        type="radio"
                                                        id="GAE"
                                                        value="GAE"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="flotte">G.A.E</label>
                                                    <input
                                                        type="radio"
                                                        id="GCE"
                                                        value="GCE"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="GCE">G.C.E</label>
                                                    <input
                                                        type="radio"
                                                        id="GCEBomber"
                                                        value="GCEBomber"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="GCEBomber">G.C.E Bomber</label>

                                                </fieldset>
                                            }
                                            {RadioSwitch === 2 &&
                                                <fieldset>
                                                    <legend>Définir une image pour l'event</legend>
                                                    <input
                                                        type="radio"
                                                        id="INF "
                                                        value="INF"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="INF">INF</label>
                                                    <input
                                                        type="radio"
                                                        id="MECA"
                                                        value="MECA"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="MECA">MECA</label>
                                                    <input
                                                        type="radio"
                                                        id="VAA"
                                                        value="VAA"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="VAA">VAA</label>

                                                </fieldset>
                                            }
                                            {RadioSwitch === 3 &&
                                                <fieldset>
                                                    <legend>Définir une image pour l'event</legend>
                                                    <input
                                                        type="radio"
                                                        id="minage "
                                                        value="minage"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="minage">Minage</label>
                                                    <input
                                                        type="radio"
                                                        id="salvage"
                                                        value="salvage"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="salvage">Salvage</label>
                                                    <input
                                                        type="radio"
                                                        id="trading"
                                                        value="trading"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="trading">Trading</label>
                                                    <input
                                                        type="radio"
                                                        id="looting"
                                                        value="looting"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="looting">Looting</label>

                                                </fieldset>
                                            }
                                            {RadioSwitch === 4 &&
                                                <fieldset>
                                                    <legend>Définir une image pour l'event</legend>
                                                    <input
                                                        type="radio"
                                                        id="autre "
                                                        value="autre"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="autre">Autre</label>
                                                    <input
                                                        type="radio"
                                                        id="jumptown "
                                                        value="jumptown"
                                                        {...register("sousBranche", { required: true })}
                                                    />
                                                    <label htmlFor="jumptown">Jumptown</label>

                                                </fieldset>
                                            }


                                        </div>

                                        <div className='activitePage__newAgenda__allDayEvent__oneDay__container__formright'>


                                            <div className='activitePage__newAgenda__allDayEvent__oneDay__container__formright__formBottom'>

                                                <div className='descriptionInput'>
                                                    <label htmlFor="eventDescription">Description de l'event: </label>
                                                    <div contentEditable type="text" className="eventDescription" name="eventDescription">Voir description dans le canal annonce le jour de l'activité.</div>
                                                </div>

                                                <div className='responsableInput'>

                                                    <span>
                                                        <p>Nombre de responsables:</p>
                                                        <input type="number" defaultValue={1} max={3} min={1} onChange={setResponsablelength} />
                                                    </span>

                                                    {responsableLength >= 1 &&
                                                        <select onChange={handleSelectChange}  {...register("responsable")} required >
                                                            <option value="" disabled selected hidden >Responsable de l'event</option>
                                                            {allMember.map((member) => (
                                                                <option key={member.discordID} id={member.discordID} value={member.discordID} >{member.pseudoFCU}</option>
                                                            ))}
                                                        </select>
                                                    }
                                                    {responsableLength >= 2 &&
                                                        <select onChange={handleSelectChange}  {...register("responsable2")} required >
                                                            <option value="" disabled selected hidden >Responsable de l'event</option>
                                                            {allMember.map((member) => (
                                                                <option key={member.discordID} id={member.discordID} value={member.discordID} >{member.pseudoFCU}</option>
                                                            ))}
                                                        </select>
                                                    }
                                                    {responsableLength >= 3 &&
                                                        <select onChange={handleSelectChange}  {...register("responsable3")} required >
                                                            <option value="" disabled selected hidden >Responsable de l'event</option>
                                                            {allMember.map((member) => (
                                                                <option key={member.discordID} id={member.discordID} value={member.discordID} >{member.pseudoFCU}</option>
                                                            ))}
                                                        </select>
                                                    }
                                                </div>


                                                {/* <div className='activitePage__newAgenda__allDayEvent__oneDay__container__formright__formBottom__checkbox'>
                                                <div>
                                                    <label htmlFor="eventQuete">Activité pour quetes Hebdo ?</label>
                                                    <input type="checkbox" className="eventQuete" name="eventQuete" {...register("quetes")} />
                                                </div>
                                                <div>
                                                    <label htmlFor="eventOpen">Activité ouverte au publique ?</label>
                                                    <input type="checkbox" className="eventOpen" name="eventOpen" {...register("open")} />
                                                </div>
                                            </div> */}

                                            </div>
                                            <input className='createEventValidateInput' type="submit" value="Valider l'event" />

                                        </div>

                                    </div>

                                </div>
                                :
                                <div className='activitePage__newAgenda__allDayEvent__oneDay__QL'>
                                    <h2>Quartier libre</h2>
                                    <div>
                                        <label htmlFor="eventDate"><FontAwesomeIcon icon={faCalendar} /></label>
                                        <input type="text" className="QLinput" name="eventDate" {...register("date")} required />
                                    </div>
                                    <input className='createEventValidateInputQL' type="submit" value="Valider l'event" />

                                </div>
                            }
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreationEventPage;